import React, { useState } from 'react';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined in your config/api.js
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

const AddInWordProduct = () => {
    const [customerName, setCustomerName] = useState('');
    const [description, setDescription] = useState('');
    const [giverName, setGiverName] = useState('');
    const [productImage, setProductImage] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleImageChange = (event) => {
        setProductImage(event.target.files[0]);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!customerName || !description  || !productImage) {
            alert('Please fill in all fields');
            return;
        }

        const formData = new FormData();
        formData.append('customer_name', customerName);
        formData.append('description', description);
        formData.append('giver_name', 'abc');
        formData.append('product_image', productImage);
        formData.append('staff_id', 1);

        setLoading(true);

        try {
            const response = await fetch(`${BASE_URL}in-word-products`, {
                method: 'POST',
                body: formData,
            });
            const data = await response.json();

            if (data.status === 1) {
                 Swal.fire({
            icon: 'success',
            title: 'Product Add success'
                });

                navigate('/InWordProductsList');
            } else {
                alert(data.message || 'Failed to add product');
            }
        } catch (error) {
            console.error('Error adding product:', error);
            alert('Something went wrong. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Add Product</h3>
                        </div>
                    </div>
                </div>
            </div>

            {/* Form start */}
            <section className="section">
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header">
                                <h4>Add Product Details</h4>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="customerName" className="form-label">Customer Name</label>
                                        <input
                                            type="text"
                                            id="customerName"
                                            className="form-control"
                                            value={customerName}
                                            onChange={(e) => setCustomerName(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="description" className="form-label">Description</label>
                                        <textarea
                                            id="description"
                                            className="form-control"
                                            value={description}
                                            onChange={(e) => setDescription(e.target.value)}
                                            required
                                        />
                                    </div>
                                    {/* <div className="mb-3">
                                        <label htmlFor="giverName" className="form-label">Giver Name</label>
                                        <input
                                            type="text"
                                            id="giverName"
                                            className="form-control"
                                            value={giverName}
                                            onChange={(e) => setGiverName(e.target.value)}
                                            required
                                        />
                                    </div> */}
                                    <div className="mb-3">
                                        <label htmlFor="productImage" className="form-label">Product Image</label>
                                        <input
                                            type="file"
                                            id="productImage"
                                            className="form-control"
                                            onChange={handleImageChange}
                                            required
                                        />
                                    </div>
                                    <div className="text-end">
                                        <button type="submit" className="btn btn-primary" disabled={loading}>
                                            {loading ? 'Adding...' : 'Add Product'}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Form end */}
        </div>
    );
};

export default AddInWordProduct;
